import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, LinkData } from '../../types'
import { CmsConverterService, defaultLinkData } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class SplitContainerContentButtonConverter extends CmsConverterService<SplitContainerContentButtonData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      button: formData.st_link ?? defaultLinkData,
      highlight: formData.st_highlighted?.value ?? false,
    }
  }
}

export const SPLIT_CONTAINER_CONTENT_BUTTON_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, SplitContainerContentButtonData>>('SplitContainerContentButtonConverter')

export interface SplitContainerContentButtonData extends ConvertedComponentData {
  button: LinkData;
  highlight: boolean;
}
